import { render, staticRenderFns } from "./DocumentLogs.vue?vue&type=template&id=7c804b27"
import script from "./DocumentLogs.vue?vue&type=script&lang=js"
export * from "./DocumentLogs.vue?vue&type=script&lang=js"
import style0 from "./DocumentLogs.vue?vue&type=style&index=0&id=7c804b27&prod&lang=scss"
import style1 from "./DocumentLogs.vue?vue&type=style&index=1&id=7c804b27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports